module.exports = "<div class=\"component-input-control form-control\"> <input type=text class=\"search dynamic-form-input ui-width\"> <span class=error> <div class={{error_msg}} id=error_tip style=display:none> <em class={{ui_error_arrow}}></em> <pre>{{ regErrorMsg }}</pre> </div> </span> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/input-control/input-control.wx.html
// module id = 1931
// module chunks = 50